import { CascadiaColor, CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import { Text as AriaText, TextProps } from "react-aria-components";

import { useColors } from "../../hooks/useColors";
import { getTextStyle } from "../../foundations/typography/styles";

interface Props extends Omit<TextProps, "style"> {
  style?: CascadiaTypographyStyle;
  color?: CascadiaColor;
  truncate?: boolean;
}

export function _Text(props: Props) {
  const { style, color, truncate = false, ...textProps } = props;

  const colors = useColors();

  const className = useMemo(
    () => css(style && getTextStyle(style), color && { color: colors[color] }),
    [colors, style, color]
  );

  if (!props.children) {
    return null;
  }

  if (!props.slot) {
    return (
      <span
        className={css(
          props.style && getTextStyle(props.style),
          props.color && { color: colors[props.color] },
          truncate && {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "pre-wrap",
          }
        )}
        {...textProps}
      >
        {props.children}
      </span>
    );
  }

  return <AriaText {...mergeProps(textProps, { className })} />;
}
